import type { Components } from '@mui/material/styles';

import type { Theme } from '../theme/types';
import { CheckboxCheckedIcon, CheckboxIcon, CheckboxIndeterminateIcon } from './icons';

export const MuiCheckbox = {
  defaultProps: {
    checkedIcon: <CheckboxCheckedIcon />,
    color: 'primary',
    disableRipple: true,
    icon: <CheckboxIcon />,
    indeterminateIcon: <CheckboxIndeterminateIcon />,
  },
  styleOverrides: {
    root: {
      borderRadius: '8px',
      padding: 0,
      '&.Mui-focusVisible': { outline: '2px solid var(--mui-palette-primary-main)' },
    },
  },
} satisfies Components<Theme>['MuiCheckbox'];
